import React from 'react';

import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import Layout from 'src/components/layout';
import { PATH } from 'src/pages/userRegistrationChange';
import { SCREENS } from 'src/constants/screens';

const UserRegistrationChangeRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        index: true,
        path: PATH,
        element: loadable(() => import('src/pages/userRegistrationChange')),
        title: t('user_registration_change.title'),
        screenId: SCREENS.R1512,
      },
    ],
  },
];

export default UserRegistrationChangeRoute;
